import Client from "../client";

export class Favorites {
  static async update(favoriteUserObjectId: string) {
    return await Client.post<any>(`/favorite`, { favoriteUserObjectId });
  }
}
